import { HUD_STYLES } from "../../../../components/ui/GameHudStyles";

export default function FakeGameInterface({ spotlightZone, highlightTab }) {
  const activeTab = highlightTab || "mission";

  const dimmed = (zone) => spotlightZone && spotlightZone !== zone
    ? { opacity: 0.18, transition: "opacity .4s", pointerEvents: "none" }
    : { transition: "opacity .4s" };

  const highlighted = (zone) => spotlightZone === zone
    ? { position: "relative", zIndex: 102 }
    : {};

  return (
    <>
      <style>{HUD_STYLES}</style>
      <div style={{ display: "flex", height: "100vh", width: "100%", background: "#02030a", color: "#fff", overflow: "hidden", fontFamily: "ui-monospace,'SF Mono',Menlo,monospace" }}>

        {/* ── HUD GAUCHE ── */}
        <aside style={{ width: 288, display: "flex", flexDirection: "column", padding: "12px", gap: 0, flexShrink: 0, overflow: "hidden" }}>
          <div className="hud-panel hud-panel-cyan" style={{ flex: 1, minHeight: 0, gap: 0 }}>

            <div className="hud-sec" style={{ ...dimmed("timer"), ...highlighted("timer") }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <svg width="52" height="52" viewBox="0 0 40 40" style={{ flexShrink: 0 }}>
                  <circle cx="20" cy="20" r="16" fill="none" stroke="rgba(99,102,241,.12)" strokeWidth="3.5" />
                  <circle cx="20" cy="20" r="16" fill="none" stroke="#818cf8" strokeWidth="3.5"
                    strokeDasharray="100.53" strokeDashoffset="25"
                    strokeLinecap="round" transform="rotate(-90 20 20)"
                    style={{ filter: "drop-shadow(0 0 4px rgba(99,102,241,.55))" }} />
                  <text x="20" y="24" textAnchor="middle" fill="rgba(99,102,241,.75)" fontSize="7" fontFamily="ui-monospace" fontWeight="800" letterSpacing="0.5">OK</text>
                </svg>
                <div>
                  <div className="hud-timer-lbl">Temps restant</div>
                  <div className="hud-timer-val">59:42</div>
                </div>
              </div>
            </div>

            <div className="hud-sec" style={{ ...dimmed("scenario-tracker"), ...highlighted("scenario-tracker") }}>
              <div className="hud-jrn-card">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, position: "relative", zIndex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                    <div style={{ width: 7, height: 7, borderRadius: "50%", background: "rgba(6,182,212,1)", boxShadow: "0 0 10px rgba(6,182,212,1)", flexShrink: 0, animation: "hud-pulse-dot 2s ease-in-out infinite" }} />
                    <span style={{ fontSize: 9, letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(6,182,212,.75)", fontWeight: 700 }}>Journal de mission</span>
                  </div>
                  <span style={{ fontSize: 9, color: "rgba(6,182,212,.45)", fontWeight: 700 }}>1/19 ▾</span>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 5, position: "relative", zIndex: 1 }}>
                  {["Protocole d'urgence activé", "PaperFold a annoncé un clone", "Serveurs Origami hors ligne"].map((t, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 6, fontSize: 10, color: "rgba(148,163,184,.8)", lineHeight: 1.4 }}>
                      <div style={{ width: 12, height: 12, borderRadius: 3, border: "1px solid rgba(52,211,153,.5)", background: "rgba(52,211,153,.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>
                        <svg width="7" height="7" viewBox="0 0 8 8"><path d="M1.5 4L3.5 6L6.5 2" stroke="rgba(52,211,153,.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /></svg>
                      </div>
                      {t}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="hud-sec" style={{ ...dimmed("hand-raise"), ...highlighted("hand-raise") }}>
              <div style={{ display: "flex", gap: 6 }}>
                <button className="hud-abtn hud-abtn-hand">✋ Lever la main</button>
              </div>
            </div>

            <div className="hud-tab-bar" style={{ ...dimmed("workspace"), ...highlighted("workspace") }}>
              {["mission", "notes", "shared"].map(tab => (
                <div key={tab} className={`hud-tab${activeTab === tab ? " hud-tab-on" : ""}`}>
                  {tab === "mission" ? "Mission" : tab === "notes" ? "Notes" : "Partagés"}
                </div>
              ))}
            </div>

            <div style={{ padding: "10px 12px", flex: 1, minHeight: 0, overflowY: "auto", ...dimmed("workspace"), ...highlighted("workspace") }}>
              {activeTab === "mission" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <div style={{ fontSize: 11, color: "rgba(148,163,184,.8)", letterSpacing: ".1em", textTransform: "uppercase", fontWeight: 700 }}>Guide — Étape 1</div>
                  <div style={{ display: "flex", gap: 5, marginBottom: 4 }}>
                    {["Récents", "Résolus", "Anciens"].map((f, i) => (
                      <div key={f} style={{ flex: 1, fontSize: 10, padding: "4px 6px", borderRadius: 8, textAlign: "center", border: i === 0 ? "1px solid rgba(99,102,241,.45)" : "1px solid rgba(255,255,255,.08)", background: i === 0 ? "rgba(99,102,241,.18)" : "rgba(255,255,255,.03)", color: i === 0 ? "rgba(165,180,252,1)" : "rgba(100,116,139,.65)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".05em" }}>{f}</div>
                    ))}
                  </div>
                  {["Trouver le code d'accès aux serveurs", "Identifier la source de la fuite"].map((t, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "7px 9px", borderRadius: 7, background: "rgba(255,255,255,.025)", border: "1px solid rgba(255,255,255,.06)" }}>
                      <div style={{ width: 15, height: 15, borderRadius: 4, border: "1.5px solid rgba(100,116,139,.45)", flexShrink: 0, marginTop: 2 }} />
                      <span style={{ fontSize: 12, color: "rgba(226,232,240,.88)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.5 }}>{t}</span>
                    </div>
                  ))}
                </div>
              )}
              {activeTab === "notes" && <div style={{ fontSize: 12, color: "rgba(100,116,139,.6)", fontFamily: "ui-sans-serif,system-ui" }}>Vos notes apparaîtront ici…</div>}
              {activeTab === "shared" && <div style={{ fontSize: 12, color: "rgba(100,116,139,.6)", fontFamily: "ui-sans-serif,system-ui" }}>Aucun élément partagé pour l'instant.</div>}
            </div>

            <div className="hud-inv" style={{ flexShrink: 0 }}>
              <div className="hud-inv-dot" />
              <div className="hud-inv-txt">Inventaire vide</div>
            </div>
          </div>
        </aside>

        {/* ── ZONE CENTRALE ── */}
        <main style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", position: "relative", ...dimmed("center-room"), ...highlighted("center-room") }}>
          <div style={{ position: "relative", aspectRatio: "1", height: "80vh", width: "auto" }}>
            <img src="/assets/s1-p1-room.webp" alt="Salle de jeu"
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain" }} />
            {spotlightZone === "center-room" && (
              <>
                <div style={{ position: "absolute", top: "10%", left: "55%", width: 56, height: 56, borderRadius: "50%", border: "2px solid rgba(245,158,11,.8)", background: "rgba(245,158,11,.15)", animation: "hud-pulse-dot 1.5s ease-in-out infinite" }} />
                <div style={{ position: "absolute", top: "35%", left: "65%", width: 44, height: 44, borderRadius: "50%", border: "2px solid rgba(245,158,11,.8)", background: "rgba(245,158,11,.15)", animation: "hud-pulse-dot 1.5s ease-in-out infinite", animationDelay: ".6s" }} />
              </>
            )}
          </div>
        </main>

        {/* ── HUD DROIT ── */}
        <aside style={{ width: 288, display: "flex", flexDirection: "column", padding: "12px", flexShrink: 0, overflow: "hidden" }}>
          <div className="hud-panel hud-panel-indigo" style={{ flex: 1, minHeight: 0 }}>

            <div className="hud-sec" style={{ display: "flex", gap: 6, ...dimmed("brief", "hints-button"), ...(spotlightZone === "brief" || spotlightZone === "hints-button" ? { position: "relative", zIndex: 102 } : {}) }}>
              <button className="hud-ta-btn hud-ta-brief">
                <svg width="28" height="28" viewBox="0 0 28 28" style={{ flexShrink: 0 }}>
                  <circle cx="14" cy="14" r="11" fill="none" stroke="rgba(99,102,241,.12)" strokeWidth="2" />
                  <circle cx="14" cy="14" r="11" fill="none" stroke="rgba(99,102,241,.7)" strokeWidth="2" strokeDasharray="69.1" strokeDashoffset="42" strokeLinecap="round" transform="rotate(-90 14 14)" style={{ filter: "drop-shadow(0 0 3px rgba(99,102,241,.6))" }} />
                  <text x="14" y="18" textAnchor="middle" fill="rgba(99,102,241,.75)" fontSize="8" fontFamily="ui-monospace" fontWeight="700">B</text>
                </svg>
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <div style={{ fontSize: 8, letterSpacing: ".14em", textTransform: "uppercase", fontWeight: 700, color: "rgba(129,140,248,.75)" }}>Accès</div>
                  <div style={{ fontSize: 12, fontWeight: 900, color: "rgba(165,180,252,.98)", textShadow: "0 0 10px rgba(99,102,241,.4)" }}>BRIEF</div>
                </div>
              </button>
              <button className="hud-ta-btn hud-ta-hints">
                <svg width="28" height="28" viewBox="0 0 28 28" style={{ flexShrink: 0 }}>
                  <circle cx="14" cy="14" r="11" fill="none" stroke="rgba(245,158,11,.1)" strokeWidth="2" />
                  <circle cx="14" cy="14" r="11" fill="none" stroke="rgba(245,158,11,.75)" strokeWidth="2" strokeDasharray="69.1" strokeDashoffset="28" strokeLinecap="round" transform="rotate(-90 14 14)" style={{ filter: "drop-shadow(0 0 3px rgba(245,158,11,.55))" }} />
                  <text x="14" y="18" textAnchor="middle" fill="rgba(245,158,11,.8)" fontSize="8" fontFamily="ui-monospace" fontWeight="700">I</text>
                </svg>
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <div style={{ fontSize: 8, letterSpacing: ".14em", textTransform: "uppercase", fontWeight: 700, color: "rgba(251,191,36,.75)" }}>Module</div>
                  <div style={{ fontSize: 12, fontWeight: 900, color: "rgba(253,186,116,.98)", textShadow: "0 0 10px rgba(245,158,11,.35)" }}>INDICES</div>
                </div>
              </button>
            </div>

            <div style={{ padding: "8px 12px 4px", display: "flex", alignItems: "center", justifyContent: "space-between", zIndex: 2, position: "relative", ...dimmed("team"), ...highlighted("team") }}>
              <span style={{ fontSize: 10, letterSpacing: ".14em", color: "rgba(148,163,184,.85)", textTransform: "uppercase", fontWeight: 700 }}>Équipe en mission</span>
              <span style={{ fontSize: 10, color: "rgba(148,163,184,.6)", fontWeight: 600 }}>Étape 1 · 4J</span>
            </div>

            <div style={{ padding: "4px 8px", display: "flex", flexDirection: "column", gap: 4, flex: 1, minHeight: 0, overflowY: "auto", ...dimmed("team"), ...highlighted("team") }}>
              {[
                { name: "Alice", role: "Coordinatrice", av: "hud-av-1", pc: "hud-pc-me", isMe: true },
                { name: "Bob", role: "Analyste données", av: "hud-av-2", pc: "hud-pc-2" },
                { name: "Charlie", role: "Tech sécurité", av: "hud-av-3", pc: "hud-pc-3" },
                { name: "Diana", role: "Support terrain", av: "hud-av-4", pc: "hud-pc-4" },
              ].map((p, i) => (
                <div key={i} className={`hud-pcard ${p.pc}`}>
                  <div className={`hud-av ${p.av}`}>{p.name.slice(0, 2).toUpperCase()}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "rgba(241,245,249,.95)", display: "flex", alignItems: "center", gap: 5, lineHeight: 1.3, fontFamily: "ui-sans-serif,system-ui" }}>
                      {p.name}
                      {p.isMe && <span className="hud-ptag">toi</span>}
                    </div>
                    <div style={{ fontSize: 11, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", marginTop: 2 }}>{p.role}</div>
                    <div style={{ fontSize: 10, color: "rgba(148,163,184,.55)", fontFamily: "ui-monospace,monospace", marginTop: 1 }}>Bureau principal</div>
                  </div>
                  <div style={{ width: 36, height: 36, borderRadius: 7, overflow: "hidden", background: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.12)", flexShrink: 0, position: "relative" }}>
                    <img src="/assets/s1-p1-room.webp" alt="room" style={{ width: "100%", height: "100%", objectFit: "cover", opacity: .7 }} />
                    <div style={{ position: "absolute", top: -3, right: -3, background: "rgba(99,102,241,.9)", border: "1px solid rgba(255,255,255,.2)", borderRadius: "50%", fontSize: 7, padding: "1px 3px" }}>🔍</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="hud-divh" />

            <div style={{ padding: "6px 8px 8px", flex: "0 0 auto", display: "flex" }}>
              <div className="hud-prev-zone" style={{ minHeight: 55 }}>
                <div style={{ fontSize: 16 }}>👁</div>
                <div style={{ fontSize: 9, letterSpacing: ".12em", textTransform: "uppercase", color: "rgba(100,116,139,.7)", fontWeight: 700 }}>Aperçu de salle</div>
                <div style={{ fontSize: 10, color: "rgba(100,116,139,.55)", fontFamily: "ui-sans-serif,system-ui", textAlign: "center", padding: "0 10px" }}>Clique 🔍 sur un joueur</div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </>

  );
}